import { render } from "./ModalEmbedGallery.vue?vue&type=template&id=764aeb46"
import script from "./ModalEmbedGallery.vue?vue&type=script&lang=js"
export * from "./ModalEmbedGallery.vue?vue&type=script&lang=js"

import "./ModalEmbedGallery.vue?vue&type=style&index=0&id=764aeb46&lang=css"
script.render = render

export default script